module.exports = __webpack_public_path__ + "static/media/ulip.bbdfa204.mp3";